import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.005 19.995c.05.564.524 1.005 1.1 1.005h9.79c.61 0 1.105-.495 1.105-1.105V6.105c0-.576-.442-1.05-1.005-1.1.003.033.005.066.005.1v13.79c0 .61-.495 1.105-1.105 1.105h-9.79a1.12 1.12 0 01-.1-.005z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M5 4.105C5 3.495 5.495 3 6.105 3h9.79C16.505 3 17 3.495 17 4.105v13.79c0 .61-.495 1.105-1.105 1.105h-9.79C5.495 19 5 18.505 5 17.895V4.105zm3.34 10.502a.808.808 0 010-1.291 4.36 4.36 0 012.66-.9c1 0 1.923.335 2.66.9.43.329.43.962 0 1.291-.737.565-1.66.9-2.66.9-1 0-1.923-.335-2.66-.9zm2.658-2.965c1.136 0 2.058-1.153 2.058-2.575 0-1.422-.922-2.574-2.058-2.574-1.137 0-2.058 1.152-2.058 2.574s.921 2.575 2.058 2.575z",
      "clip-rule": "evenodd"
    })
  ]))
}